import { useEffect } from "react";
import { useCmpEventListener } from "./cmp/cmp-event-listener";
import { CMP_HEALTH_TIMEOUT_MS } from "./cmp/constants";
import { useConsentApplied } from "./cmp/use-consent-applied";
import { useVendorHealthCheck } from "./health-check/use-vendor-health-check";
import { SYNERISE_HEALTH_TIMEOUT_MS } from "./synerise/constants";
import { SrEventListener } from "./synerise/sr-event-listener";
import { SyneriseScript } from "./synerise/synerise-script";

export function AnalyticsHub() {
  const { initializeCmpListeners } = useCmpEventListener();
  const consentApplied = useConsentApplied();

  useVendorHealthCheck(
    "cmp",
    () => typeof window.__cmp === "function" && !("a" in window.__cmp),
    CMP_HEALTH_TIMEOUT_MS,
  );

  useVendorHealthCheck("synerise", () => !!window.SR?.event, SYNERISE_HEALTH_TIMEOUT_MS, consentApplied);

  useEffect(() => {
    initializeCmpListeners();
  }, [initializeCmpListeners]);

  return (
    <>
      <SyneriseScript />
      <SrEventListener />
    </>
  );
}
